import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './Form.styles';
const FormField = ({ showLabel = true, ...otherProps }) => {
    const errorToShow = Array.isArray(otherProps.error)
        ? otherProps.error.find((error) => !!error)
        : otherProps.error;
    const name = Array.isArray(otherProps.name) ? otherProps.name[0] : otherProps.name;
    return (React.createElement(S.Field, { "data-size": otherProps.size ?? 'default', "data-error": !!errorToShow },
        otherProps.label && (React.createElement(S.Label, { htmlFor: name, "data-hide": !showLabel, "data-required": otherProps.required },
            otherProps.label,
            otherProps.tooltip && (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.Info, { "aria-label": "More Information", "aria-describedby": `${name}-label`, onClick: (e) => e.preventDefault() },
                    "?",
                    React.createElement(S.Tooltip, { id: `${name}-label`, role: "tooltip" }, otherProps.tooltip)))))),
        otherProps.description && (React.createElement(S.Description, { dangerouslySetInnerHTML: { __html: otherProps.description } })),
        otherProps.children,
        errorToShow && (React.createElement(S.Error, null,
            React.createElement("span", null, "!"),
            " ",
            errorToShow.message))));
};
export default FormField;
